import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ManagerLogin = () => {
  const navigate = useNavigate();

  const [passwordType, setPasswordType] = useState("password");
  const [userdata, setUserdata] = useState({
    email: "",
    password: "",
  });

  const togglePassword = () => {
    setPasswordType((prev) =>
      prev === "password" ? "text" : "password"
    );
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
  };

  const postdata = async (e) => {
    e.preventDefault();
    const { email, password } = userdata;

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      toast.error("Invalid Email");
      return;
    }

    try {
      const res = await fetch(
        "https://server-side-influencer.onrender.com/manager/managerlogin",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        toast.success(data.message);

        const managerId = data.user.managerId;

        localStorage.setItem("mangertoken", data.token);
        localStorage.setItem("managerID", managerId);
        sessionStorage.setItem("sessionId", data.sessionId);

        const savedFcmToken = localStorage.getItem("fcmToken");

        if (savedFcmToken && managerId) {
          try {
            await fetch(
              "https://server-side-influencer.onrender.com/manager/save-fcm-token",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  managerId,
                  fcmToken: savedFcmToken,
                }),
              }
            );
          } catch (err) {
            console.error("Error saving FCM token:", err);
          }
        }

        navigate("/ManagerHome");
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error("Login failed. Try again.");
    }
  };

  const navigateToForgotPassword = () => {
    navigate("/manageemail");
  };

  return (
    <div className="font-[sans-serif]">
      <div
        className="min-h-screen flex flex-col items-center justify-center py-6 px-4"
        style={{ marginTop: "1%" }}
      >
        <div className="grid md:grid-cols-2 items-center gap-4 max-w-6xl w-full">
          <div className="border border-gray-300 rounded-lg p-6 max-w-md shadow-[0_2px_22px_-4px_rgba(93,96,127,0.2)] max-md:mx-auto">
            <form className="space-y-4" onSubmit={postdata}>
              <div className="mb-8">
                <h3 className="text-gray-800 text-3xl font-extrabold">
                  Sign in As Agency
                </h3>
                <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                  Sign in as an agency or manager to streamline influencer
                  campaigns and manage multiple talent profiles in one place.
                </p>
              </div>

              <div>
                <label className="text-gray-800 text-sm mb-2 block">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  required
                  className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
                  placeholder="Enter email"
                  value={userdata.email}
                  onChange={handleInput}
                />
              </div>

              <div>
                <label className="text-gray-800 text-sm mb-2 block">
                  Password
                </label>
                <div className="relative flex items-center">
                  <input
                    name="password"
                    type={passwordType}
                    required
                    className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
                    placeholder="Enter password"
                    value={userdata.password}
                    onChange={handleInput}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#bbb"
                    stroke="#bbb"
                    className="w-[18px] h-[18px] absolute right-4 cursor-pointer"
                    viewBox="0 0 24 24"
                    onClick={togglePassword}
                  >
                    <path d="M12 4C8.13 4 5 6.91 5 10s3.13 6 7 6 7-2.91 7-6-3.13-6-7-6zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                  </svg>
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={navigateToForgotPassword}
                  className="text-blue-600 hover:underline font-semibold text-sm"
                >
                  Forgot your password?
                </button>
              </div>

              <div className="!mt-8">
                <button
                  type="submit"
                  className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-90"
                >
                  Log in
                </button>
              </div>
            </form>
          </div>

          {/* LOGO SECTION */}
          <div className="flex items-center justify-center max-md:mt-8">
            <div className="flex items-center gap-3 whitespace-nowrap">
              <img
                src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
                alt="Influenceso Logo"
                className="h-12 w-auto"
              />
              <h2 className="text-2xl font-semibold text-black flex items-baseline gap-2">
                <span className="font-bold">Influenceso</span>
                <span className="text-gray-600 text-lg">
                  for manager
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer autoClose={500} />
    </div>
  );
};

export default ManagerLogin;